import { today } from '@squadcore/api/shared/time'
import { createFileRoute } from '@tanstack/react-router'
import { AttendancePage } from '~/features/training/AttendancePage'
import { resolveRange, type AttendanceSearch } from '~/features/training/search'
import { attendanceQuery } from '~/features/training/queries'
import { loaderScope } from '~/lib/session'

const isDate = (v: unknown): v is string => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)

export const Route = createFileRoute('/_app/training/anwesenheit')({
  validateSearch: (s: Record<string, unknown>): AttendanceSearch => ({
    ...(s.view === 'termine' || s.view === 'heatmap' ? { view: s.view } : {}),
    ...(s.range === '4w' || s.range === '3m' || s.range === 'frei' ? { range: s.range } : {}),
    ...(isDate(s.from) ? { from: s.from } : {}),
    ...(isDate(s.to) ? { to: s.to } : {}),
    ...(s.inaktive === true || s.inaktive === 'true' ? { inaktive: true } : {}),
  }),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    const scope = await loaderScope(context.queryClient)
    if (!scope?.teamId) return
    await context.queryClient.ensureQueryData(attendanceQuery(scope.teamId, scope.season, resolveRange(deps, today(scope.timezone)))).catch(() => undefined)
  },
  component: function Attendance() {
    return <AttendancePage search={Route.useSearch()} />
  },
})
